import { PlaycastData, initialPlaycastData } from './player/types';
import { ReactNode, createContext, useEffect, useState, useSyncExternalStore } from 'react';
import { store } from './player/store';
import { captureStore } from '@playcastdotio/InputCapture';
import { gamepadStore } from '@playcastdotio/MobileGamepad';
import { handleEvent, setGamepadState } from '../api/hostMessaging/inputEvents';

export const PlaycastContext = createContext<PlaycastData>(initialPlaycastData);

type LocalProps = {
  children?: ReactNode;
};

export const Playcast = (props: LocalProps) => {
  const { children } = props;
  const [data, setData] = useState<PlaycastData>(store.getData());
  const gamepad = useSyncExternalStore(gamepadStore.subscribeGamepad, gamepadStore.getGamepad);

  const event = useSyncExternalStore(captureStore.subscribeEvent, captureStore.getEvent);

  // This is processing for the mobile gamepad overlay
  useEffect(() => {
    if (gamepad) {
      setGamepadState(gamepad);
    }
  }, [gamepad]);

  useEffect(() => {
    if (event) {
      handleEvent(event);
    }
  }, [event]);

  const dataHandler = () => {
    console.log('data refresh');
    const d = store.getData();
    setData({ ...d });
  };

  useEffect(() => {
    console.log('adding event listener, data refresh');
    window.addEventListener('playcastDataRefreshed', dataHandler);
    return () => {
      console.log('removing event listener, data refresh');
      window.removeEventListener('playcastDataRefreshed', dataHandler);
    };
  }, []);

  // const connectionChangedHandler = () => {
  //   const newState = store.getData().peerManager?.dataConnectionState || 'invalid';
  //   console.log('data connection state: '.concat(newState));
  // };

  // useEffect(() => {
  //   console.log('adding event listener, data connection change');
  //   window.addEventListener('playcastDataConnectionChanged', connectionChangedHandler as EventListener);
  //   return () => {
  //     console.log('removing event listener, data connection change');
  //     window.removeEventListener('playcastDataConnectionChanged', connectionChangedHandler as EventListener);
  //   };
  // }, []);

  return <PlaycastContext.Provider value={data}>{children}</PlaycastContext.Provider>;
};
